import { render, staticRenderFns } from "./MailListingAllPage.vue?vue&type=template&id=0642c4a0&scoped=true&"
import script from "./MailListingAllPage.vue?vue&type=script&lang=js&"
export * from "./MailListingAllPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642c4a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
